export default __webpack_public_path__ + "static/egress-1-e06d12de72cbddf4d3aaab42c3f809dd.webp";